module.exports = __webpack_public_path__ + "img/fanhuiicon.627d60c5.svg";